import React from 'react'


const CTA = () => {
  return (
     <div className="cta fade-in">
            <a href={"https://drive.google.com/file/d/1D-3MYARiM1ZT03DsEPOrDFEJXFG0Cpuq/view?usp=drive_link"} className="btn" download>Baixar CV</a>
            <a href="#contact" className="btn btn-primary">Vamos conversar</a>
          </div>
  )
}

export default CTA